import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    itemsWrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',

      '& > *': {
        borderRadius: 0,
      },
      '& > *:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
      },
      '& > *:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
      },
    },
    formulaItem: {
      '&:hover': {
        zIndex: 1,
      },
    },
    blockCustomFormula: {
      padding: 0,
    },
    alignRight: {
      justifyContent: 'flex-end',
    },
    alignLeft: {
      justifyContent: 'flex-start',
    },
  }),
  { name: 'BlockFormula' }
);
